
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Button from '../base/Button';
import { appStoreUrlHeaderCta, googlePlayUrlHeaderCta } from '@/utils/appStoreUtm';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'ホーム', href: '/' },
    { name: '旅行タイプ診断', href: '/diagnosis' },
    { name: '旅行記事', href: '/articles' },
  ];

  const isActive = (href: string) => {
    if (href === '/') {
      return location.pathname === '/';
    }
    if (href === '/diagnosis') {
      return (
        location.pathname === '/diagnosis' || location.pathname.startsWith('/diagnosis-result')
      );
    }
    return location.pathname.startsWith(href);
  };

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-[#E5E7EB] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/1353b4d17a02b45708268c01077fcf18.png"
              alt="SOCIAL TRIP"
              className="h-8 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors hover:text-[#02D0F0] ${
                  isActive(item.href)
                    ? 'text-[#02D0F0] border-b-2 border-[#02D0F0] pb-1'
                    : 'text-[#6B7280]'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-2">
            <a href={appStoreUrlHeaderCta()} target="_blank" rel="noopener noreferrer">
              <Button size="sm" className="flex items-center">
                <i className="ri-apple-fill w-4 h-4 mr-2" aria-hidden />
                App Store
              </Button>
            </a>
            <a href={googlePlayUrlHeaderCta()} target="_blank" rel="noopener noreferrer">
              <Button size="sm" variant="outline" className="flex items-center">
                <i className="ri-google-play-fill w-4 h-4 mr-2" aria-hidden />
                Google Play
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-[#6B7280] hover:text-[#02D0F0] p-2"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#E5E7EB]">
            <nav className="flex flex-col space-y-3 sm:space-y-4 px-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-sm sm:text-base font-medium transition-colors hover:text-[#02D0F0] py-2 ${
                    isActive(item.href) ? 'text-[#02D0F0]' : 'text-[#6B7280]'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="flex flex-col gap-2 mt-2 sm:mt-4 w-full">
                <a href={appStoreUrlHeaderCta()} target="_blank" rel="noopener noreferrer" className="w-full">
                  <Button size="sm" className="flex items-center justify-center w-full">
                    <i className="ri-apple-fill w-4 h-4 mr-2" aria-hidden />
                    App Storeでダウンロード
                  </Button>
                </a>
                <a href={googlePlayUrlHeaderCta()} target="_blank" rel="noopener noreferrer" className="w-full">
                  <Button size="sm" variant="outline" className="flex items-center justify-center w-full">
                    <i className="ri-google-play-fill w-4 h-4 mr-2" aria-hidden />
                    Google Playでダウンロード
                  </Button>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
